export enum FedopsInteractions {
  CreateOrderPageHttpRequest = 'create-order-page-http-request',
  InitializeOrderPage = 'initialize-order-page',
  SubmitOrderPage = 'submit-order-page',
  AppRendered = 'app-rendered',
}

export interface FedopsLoggerInstance {
  appLoaded(): void;
  interactionStarted(interactionName: string): void;
  interactionEnded(interactionName: string): void;
}

export class FedopsLogger {
  constructor(private readonly fedopsLogger: FedopsLoggerInstance) {}

  async withInteraction(
    interactionName: string,
    callback: () => Promise<void>,
  ) {
    this.fedopsLogger.interactionStarted(interactionName);
    await callback();
    this.fedopsLogger.interactionEnded(interactionName);
  }

  appLoaded = () => {
    this.fedopsLogger.appLoaded();
  };

  withCreateOrderPageHttpInteraction = (callback: () => Promise<void>) =>
    this.withInteraction(
      FedopsInteractions.CreateOrderPageHttpRequest,
      callback,
    );

  beginCreateOrderPageHttpRequestInteraction() {
    this.fedopsLogger.interactionStarted(
      FedopsInteractions.CreateOrderPageHttpRequest,
    );
  }

  beginInitializeOrderPageInteraction() {
    this.fedopsLogger.interactionStarted(
      FedopsInteractions.InitializeOrderPage,
    );
  }

  endInitializeOrderPageInteraction() {
    this.fedopsLogger.interactionEnded(FedopsInteractions.InitializeOrderPage);
  }

  beginSubmitOrderPageInteraction() {
    this.fedopsLogger.interactionStarted(FedopsInteractions.SubmitOrderPage);
  }
  endSubmitOrderPageInteraction() {
    this.fedopsLogger.interactionEnded(FedopsInteractions.SubmitOrderPage);
  }

  beginAppRenderedInteraction() {
    this.fedopsLogger.interactionStarted(FedopsInteractions.AppRendered);
  }

  endAppRenderedInteraction() {
    this.fedopsLogger.interactionEnded(FedopsInteractions.AppRendered);
  }

  endCreateOrderPageHttpRequestInteraction() {
    this.fedopsLogger.interactionEnded(
      FedopsInteractions.CreateOrderPageHttpRequest,
    );
  }
}
